import React from 'react';
import ImageBlock from '../ImageBlock/ImageBlock';
import TextBlock from '../TextBlock/TextBlock';
import './Blocks.css';

export default ({ layouts }) => (
    <div>
        <hr />
        {layouts && layouts.map(layout =>
          (layout.__typename && layout.__typename === "WordPressAcf_image_block" && <ImageBlock title={layout.title} image={layout.image} />) ||
          (layout.__typename && layout.__typename === "WordPressAcf_text_block" && <TextBlock title={layout.title} text={layout.text} />)
        )}
    </div>
);
